import React from 'react';
import polanco from './../../../../assets/img/centers/polanco.png';
import cancun from './../../../../assets/img/centers/cancun.png';
import guadalajara from './../../../../assets/img/centers/guadalajara.png';
import insurgentes from './../../../../assets/img/centers/insurgentes.png';
import juarez from './../../../../assets/img/centers/juarez.png';
import leon from './../../../../assets/img/centers/leon.png';
import merida from './../../../../assets/img/centers/merida.png';
import metepec from './../../../../assets/img/centers/metepec.png';
import monterrey from './../../../../assets/img/centers/monterrey.png';
import palmas from './../../../../assets/img/centers/palmas.png';
import puebla from './../../../../assets/img/centers/puebla.png';
import queretaro from './../../../../assets/img/centers/queretaro.png';
import santafe from './../../../../assets/img/centers/santafe.png';
import satelite from './../../../../assets/img/centers/satelite.png';
import tijuana from './../../../../assets/img/centers/tijuana.png';

class Maps extends React.Component {
    
    render() {
        const {place} = this.props;
        if(place === "juarez")
            return <img className="img-responsive" src={juarez}/>
        if(place === "polanco")
            return <img className="img-responsive" src={polanco}/>
        if(place === "cancun")
            return <img className="img-responsive" src={cancun}/>
        if(place === "guadalajara")
            return <img className="img-responsive" src={guadalajara}/>
        if(place === "insurgentes")
            return <img className="img-responsive" src={insurgentes}/>
        if(place === "leon")
            return <img className="img-responsive" src={leon}/>
        if(place === "merida")
            return <img className="img-responsive" src={merida}/>
        if(place === "metepec")
            return <img className="img-responsive" src={metepec}/>
        if(place === "monterrey")
            return <img className="img-responsive" src={monterrey}/>
        if(place === "palmas")
            return <img className="img-responsive" src={palmas}/>
        if(place === "puebla")
            return <img className="img-responsive" src={puebla}/>
        if(place === "queretaro")
            return <img className="img-responsive" src={queretaro}/>
        if(place === "santafe")
            return <img className="img-responsive" src={santafe}/>
        if(place === "satelite")
            return <img className="img-responsive" src={satelite}/>
        if(place === "tijuana")
            return <img className="img-responsive" src={tijuana}/>
        else{
            return null;
        }
    }

  
}

export default Maps;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/Maps/Maps.js